<template>
  <router-view />
</template>

<script>
import axios from "axios";
import Vue from "vue";
import VueAxios from "vue-axios";
import JsonCSV from "vue-json-csv";
import VueSession from "vue-session";
import Vuetify from "vuetify";

Vue.component("downloadCsv", JsonCSV);

Vue.use(Vuetify);
Vue.use(VueAxios, axios);
Vue.use(VueSession, { persist: true });

export default {
  name: "App",
};
</script>
